var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-logos"},[_c('img',{staticClass:"desktop-logo",attrs:{"src":"/gfu_logo.svg","alt":"gfu logo"}}),_c('img',{staticClass:"mobile-logo",attrs:{"src":"/gfu_logo_mob.svg","alt":"gfu logo"}})])
}]

export { render, staticRenderFns }